import { addMessages } from '@hana/i18n';

// Khoá chuỗi của Hoá đơn — iPad (InvoicePad.tsx). Dữ liệu mẫu và mã nghiệp vụ không dịch.
addMessages('vi', {
  'ip.title': 'Hoá đơn', 'ip.tabsAria': 'Xem hoá đơn theo trạng thái', 'ip.all': 'Tất cả',
  'ip.noWrite': 'Chưa mở ghi ở bản này', 'ip.exportMisa': 'Xuất & MISA', 'ip.exportOff': 'Xuất & MISA chưa mở ở bản này',
  'ip.mkDebit': 'Lập debit 4', 'ip.findAria': 'Tìm hoá đơn', 'ip.findPh': 'Số HĐ / debit / job / khách',
  'ip.fPer': 'Kỳ', 'ip.fSale': 'Sale', 'ip.fKind': 'Loại', 'ip.allSale': 'Mọi Sale', 'ip.allKind': 'Mọi loại',
  'ip.clear': 'Xoá lọc', 'ip.docs': '{n} chứng từ', 'ip.overTip': 'Tổng quá hạn thu',
  'ip.emptyT': 'Không có chứng từ', 'ip.emptyD': 'Đổi bộ lọc hoặc tab.', 'ip.listAria': 'Danh sách hoá đơn',
  'ip.cInv': 'Số HĐ / debit', 'ip.cCus': 'Khách hàng', 'ip.cJob': 'JobID', 'ip.cDue': 'Hạn', 'ip.cAmt': 'Số tiền · tr ₫',
  'ip.rowAria': '{id} · {cus} · {st} · {amt} triệu đồng', 'ip.locked': 'Kỳ đã khoá',
  'ip.total': 'Tổng · {n} chứng từ', 'ip.mixAria': 'Cơ cấu theo trạng thái: {list}',
});
addMessages('en', {
  'ip.title': 'Invoices', 'ip.tabsAria': 'View invoices by status', 'ip.all': 'All',
  'ip.noWrite': 'Writing is not enabled in this version', 'ip.exportMisa': 'Export & MISA', 'ip.exportOff': 'Export & MISA is not enabled in this version',
  'ip.mkDebit': 'Create debit 4', 'ip.findAria': 'Search invoices', 'ip.findPh': 'Invoice / debit / job / customer',
  'ip.fPer': 'Period', 'ip.fSale': 'Sale', 'ip.fKind': 'Type', 'ip.allSale': 'All Sales', 'ip.allKind': 'All types',
  'ip.clear': 'Clear filters', 'ip.docs': '{n} documents', 'ip.overTip': 'Total overdue',
  'ip.emptyT': 'No documents', 'ip.emptyD': 'Change the filters or tab.', 'ip.listAria': 'Invoice list',
  'ip.cInv': 'Invoice / debit', 'ip.cCus': 'Customer', 'ip.cJob': 'JobID', 'ip.cDue': 'Due', 'ip.cAmt': 'Amount · M ₫',
  'ip.rowAria': '{id} · {cus} · {st} · {amt} million VND', 'ip.locked': 'Period locked',
  'ip.total': 'Total · {n} documents', 'ip.mixAria': 'Breakdown by status: {list}',
});
